<!--阅读说明-->
<div id="swipeContainer">
  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0 && !isTencent"></div>
  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>
  <!--阅读说明-->
  <div class="surveyCard" *ngIf="surveyStatus == 1">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[3]}}</p>
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>


  <div class="surveyCard" *ngIf="surveyStatus == 2">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[2]}}</p>
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>

  <!--箭头-->
  <div id="bottomSpace">
    <div *ngIf="isPC && showPCBtn" class="pc-btn" (click)="goNext()">查看报告</div>
    <img *ngIf="!isPC" class="topArrow" src="{{assetsRoute}}/picture/reportnew/arrow.png" alt="">
  </div>
</div>

<app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

<!--报告-->
<div class="abilityReport">

  <!--音频-->
  <div class="experienceBtn clearfix" *ngIf="surveyStatus == 2" [ngClass]="{'slideUp': isSlide}">
    <div class="q6-icon" (click)="slideBtn()">
    </div>

    <p *ngIf="showInfo"><span>收听以下音频，帮你更好了解和解读报告</span></p>
    <app-audio-play id="audioPlay"></app-audio-play>
    <!--<app-audio-play *ngIf="showInfo"></app-audio-play>-->
  </div>

  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0 && !isTencent"></div>


  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>


  <!--前测-->
  <div class="abilityFrontTest" *ngIf="surveyStatus == 1">
    <!--标题-->
    <div class="reportTitle">
      <p class="courseName">{{courseName}}</p>
      <p class="title">{{pageTitle}}</p>
    </div>
    <!--学前测评-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle">{{staticDoc.title[0]}}</p>
      <!--图表-->
      <div class="lineCharts preTest lineChartsGoodBG">
        <!--后测比前测高图表-->
        <div class="specialAxis clearfix">
          <div class="lv" id="lv1"></div>
          <div class="lv" id="lv2"></div>
          <div class="lv" id="lv3"></div>
          <div class="lv" id="lv4"></div>
          <div class="lv" id="lv5"></div>
          <div class="lv" id="lv6"></div>
        </div>

        <!--前后测倒挂&&前后测等级一样-->
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li><i class="lv1"></i></li>
          <li><i class="lv2"></i></li>
          <li><i class="lv3"></i></li>
          <li><i class="lv4"></i></li>
          <li><i class="lv5"></i></li>
          <li><i class="lv6"></i></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="xAxis clearfix">
          <li>薄弱</li>
          <li>有限</li>
          <li>一般</li>
          <li>良好</li>
          <li>优秀</li>
          <li>卓越</li>
        </ul>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{levelDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>

    <!--关键行动分析-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle">{{staticDoc.title[1]}}</p>
      <p class="surveyItemCardSubTitle">{{staticDoc.KAExplain}}</p>

      <!--雷达图-->
      <div class="radarCharts" *ngIf="report">
        <app-component-charts [chartsType]="chartsType" [theme]="theme"
                              [chartsData]="chartKAsData"></app-component-charts>
      </div>
    </div>


    <!--学习建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[2]}}</div>
      </div>

      <!--学习建议内容-->
      <div class="suggestContent">
        <div class="suggestDesc">{{suggest}}</div>
        <div class="suggestList" *ngFor="let item of learningTips;let i =index">
          <div class="title">
            <div>
              <span class="iconCircle" *ngIf="item.learningTipsTitle">{{i+1}}</span>
              {{item.learningTipsTitle}}
            </div>
          </div>
          <div class="content">{{item.learningTipsContent}}</div>
        </div>
      </div>
    </div>


    <div style="height: 3.5rem" *ngIf="!isTencent">
      <div class="approachModuleWrap"
           *ngIf="!isCustomLock&&isOpenClass==0&&approachLoading && isScrollBottom && isFirstInPreOrPostTestReport && surveyStatus==1">
        <component-approach [theme]="approachTheme" [isFirst]="true" (onGoCourse)="getCourse()"></component-approach>
      </div>

      <div class="approachModuleWrap"
           *ngIf="!isCustomLock&&isOpenClass==0&&approachLoading && isScrollBottom && !isFirstInPreOrPostTestReport && surveyStatus==1">
        <component-approach [theme]="approachTheme" [isFirst]="false" (onGoCourse)="getCourse()"></component-approach>
      </div>
    </div>

    <div class="fillBottom"></div>
    <!--    <div class="bottomBtn" *ngIf="isOpenClass==0" (click)="getCourse()">进入课程学习</div>-->
  </div>

  <!--后测-->
  <div class="abilityAfterTest" *ngIf="surveyStatus == 2">
    <!--对比-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle multiLine">{{contrastSpeech}}</p>
      <!--图表-->
      <div class="lineCharts postTest lineCharts{{contrast}}BG">
        <!--后测比前测高图表-->
        <div class="specialAxis clearfix">
          <div class="lv" id="lv1"></div>
          <div class="lv" id="lv2"></div>
          <div class="lv" id="lv3"></div>
          <div class="lv" id="lv4"></div>
          <div class="lv" id="lv5"></div>
          <div class="lv" id="lv6"></div>
        </div>

        <!--前后测倒挂&&前后测等级一样-->
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li><i class="lv1"></i></li>
          <li><i class="lv2"></i></li>
          <li><i class="lv3"></i></li>
          <li><i class="lv4"></i></li>
          <li><i class="lv5"></i></li>
          <li><i class="lv6"></i></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="clearfix">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="xAxis clearfix">
          <li>薄弱</li>
          <li>有限</li>
          <li>一般</li>
          <li>良好</li>
          <li>优秀</li>
          <li>卓越</li>
        </ul>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{contrastDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>

    <!--关键行动前后对比-->
    <div class="surveyItemCard">
      <p class="surveyItemCardTitle">{{staticDoc.title[0]}}</p>
      <p class="surveyItemCardSubTitle">{{staticDoc.KAExplain}}</p>

      <!--雷达图-->
      <div class="radarCharts" *ngIf="report">
        <ul class="chartLegend">
          <li>能力诊断</li>
          <li>能力考核</li>
        </ul>
        <app-component-charts [chartsType]="chartsType" [theme]="theme"
                              [chartsData]="chartKAsData"></app-component-charts>
      </div>
    </div>

    <!--后测表现好的KA-->
    <div class="surveyItemCard" *ngIf="a_advantagesKas&&a_advantagesKas.length!==0">
      <p class="surveyItemCardTitle multiLine w-75">以下<span
        class="text-orange">{{a_advantagesKas.length}}</span>个行为你表现<br>得尤为出色</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type1.png" alt=""></div>
      <div class="keyBehaviorContent" *ngFor="let kas of a_advantagesKas;let i = index">
        <span class="labelStyle"><b>{{kas.learningTipsTitle}}</b></span><span>- {{kas.learningTipsContent}}</span>
      </div>
    </div>


    <!--仅存在待提高的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_advantagesKas&&a_advantagesKas.length==0)&&(a_shortBoardsKas&&a_shortBoardsKas.length!==0)">
      <p class="surveyItemCardTitle multiLine w-75">虽然行动并不出彩，但未来提升空间巨大！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type4.png" alt=""></div>
      <div class="keyBehaviorContent">{{advantagesFixedSpeech}}</div>
    </div>


    <!--后测待提高的KA-->
    <div class="surveyItemCard" *ngIf="a_shortBoardsKas&&a_shortBoardsKas.length!==0">
      <p class="surveyItemCardTitle multiLine w-75">以下<span class="text-red">{{a_shortBoardsKas.length}}</span>个行动还需<br>多多练习
      </p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type2.png" alt=""></div>
      <div class="keyBehaviorContent" *ngFor="let kas of a_shortBoardsKas;let i = index">
        <span class="labelStyle"><b>{{kas.learningTipsTitle}}</b></span><span>- {{kas.learningTipsContent}}</span>
      </div>
    </div>


    <!--仅存在表现好的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_shortBoardsKas&&a_shortBoardsKas.length==0)&&(a_advantagesKas&&a_advantagesKas.length!==0)">
      <p class="surveyItemCardTitle multiLine w-75">我们惊喜地发现，你暂时没有急需提高的行动！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type3.png" alt=""></div>
      <div class="keyBehaviorContent">{{shortBoardsFixedSpeech}}</div>
    </div>

    <!--即不存在表现好的KA也不存在待提高的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_shortBoardsKas&&a_shortBoardsKas.length==0)&&(a_advantagesKas&&a_advantagesKas.length==0)">
      <p class="surveyItemCardTitle multiLine w-75">你的各项行动展现都十分平稳，请再接再厉吧！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type4.png" alt=""></div>
      <div class="keyBehaviorContent">{{fixedSpeech}}</div>
    </div>


    <!--发展建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[1]}}</div>
      </div>

      <!--发展建议内容-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length!==0">
        <div class="suggestList" *ngFor="let item of developmentTipsKas;let i = index">
          <div class="suggestList-partition" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number-img" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number" *ngIf="developmentTipsKas.length > 1">{{i + 1}}</div>
          <div class="content">
            <div class="content-title-develop">{{item.a_kaName}}</div>
            <div class="content-value">{{item.a_suggest}}</div>
            <div class="content-title-develop marginY-16">实用技巧</div>
            <div class="content-group" *ngFor="let child of item.a_skill">
              <div class="dot"></div><div class="content-value">{{child}}</div>
            </div>
            <div class="content-title-skill marginY-16">发展活动</div>
            <div class="content-group" *ngFor="let child of item.a_activ">
              <div class="dot"></div><div class="content-value">{{ child }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--发展建议内容(不存在有待提高的KA)-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length==0">
        <div class="suggestList" *ngFor="let item of developmentTipsFixedSpeech;let i = index">
          <div class="content" [innerHtml]="item"></div>
        </div>
      </div>

    </div>

    <div style="height: 3.5rem"  id="approachModule" *ngIf="!isTencent">
      <div class="approachModuleWrap"
           id="approachModuleWrap"
           *ngIf="!isCustomLock&&isOpenClass==0&&approachLoading && isScrollBottom && isFirstInPreOrPostTestReport && surveyStatus==2 && !isShowBack && !isOnlyLearningPathCannotBack">
        <component-approach [theme]="approachTheme" [isFirst]="true" (onGoCourse)="finishCourse()"></component-approach>
      </div>

      <div class="approachModuleWrap" id="approachModuleWrap" *ngIf="!isCustomLock&&isOpenClass==0&&approachLoading && !isFirstInPreOrPostTestReport && surveyStatus==2 && !isShowBack && !isOnlyLearningPathCannotBack">
        <component-approach [theme]="approachTheme" [isFirst]="false"
                            (onGoCourse)="finishCourse()"></component-approach>
      </div>
    </div>


    <div class="fillBottom"></div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/ability-report-new/ability-report-new.component.html